import { formatListingDate } from '../../util/listingRules';

export const titleCaseFromSlug = str =>
  typeof str === 'string'
    ? str.replace(/[-_]+/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
    : '';

export const formatISODate = (isoDate, intl) => formatListingDate(isoDate, intl);

export const formatUnixToDate = (unixSeconds, intl) => {
  if (!unixSeconds) return '';
  const d = new Date(unixSeconds * 1000);
  if (Number.isNaN(d.getTime())) return '';
  return intl.formatDate(d, { year: 'numeric', month: 'short', day: '2-digit' });
};

export const formatPublicMoney = (moneyLike, intl) => {
  if (!moneyLike?.currency || typeof moneyLike?.amount !== 'number') return '';
  return intl.formatNumber(moneyLike.amount / 100, {
    style: 'currency',
    currency: moneyLike.currency,
    maximumFractionDigits: 0,
  });
};

export const getEnumLabelFromListingFields = (listingFields = [], fieldKey, rawValue) => {
  const field = (listingFields || []).find(f => f.key === fieldKey);
  const opts = field?.enumOptions || [];
  const found = opts.find(o => `${o.option}` === `${rawValue}`);
  return found?.label || rawValue;
};

export const getFilterParamNameForListingField = (listingFields = [], fieldKey) => {
  const field = (listingFields || []).find(f => f.key === fieldKey);
  const scope = field?.scope || 'public';
  return scope === 'public' ? `pub_${fieldKey}` : `pri_${fieldKey}`;
};
